import { SummaryConfig } from "src/hooks";

export const dsaekGradingSummaryConfig: SummaryConfig = {
    epithelium: [
        {
            accessor: "epitheliumRemoved",
            renderer: "Epithelium Removed.",
        },
        {
            accessor: "traceEpithelialPresent",
            renderer: "Trace Epithelial Remnants Present.",
        },
        {
            accessor: "epitheliumComments",
        },
    ],
    stroma: [
        {
            accessor: "stroma.posteriorThickness",
            formatter: (val) => `Approximate Graft Thickness: ${val} µm.`,
        },
        {
            accessor: "stroma.size",
            formatter: (val) => `Approximate Graft Size: ${val} mm.`,
        },
        {
            accessor: "",
            renderer: (data) => {
                const { capOrientation, capOrientationLocation } = data.stroma ?? {};
                if (!capOrientation) return "";
                if (capOrientation === "yes") {
                    return "Cap is oriented on the stromal bed within 1 mm.";
                } else {
                    return `Cap location is within ${capOrientationLocation ?? ""} mm.`;
                }
            },
        },
        {
            accessor: "stroma.sMark.checked",
            renderer: {
                "title": "'S' mark placed",
                "stroma.sMarkVisibility": "",
            },
        },
        {
            accessor: "stroma.fMark.checked",
            renderer: {
                "title": "'F' mark placed",
                "stroma.fMarkVisibility": "",
            },
        },
        {
            accessor: "stroma.linePattern.checked",
            renderer: {
                "title": "1:2 line pattern",
                "stroma.linePatternVisibility": "",
            },
        },
        {
            accessor: "stroma.centration",
            renderer: "Centration Dot Placed.",
        },
        {
            accessor: "stroma.comments",
        },
    ],
    descemets: [
        {
            accessor: "descemets.noDefects",
            renderer: (data) => {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const { noDefects, comments, ...rest } = data.descemets ?? {};
                if (noDefects) {
                    return "No Defects.";
                }
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (Object.values<any>(rest).some((v) => !!v)) {
                    return {
                        "title": "Folds",
                        "descemets.severity": "",
                        "descemets.central": "Central",
                        "descemets.midPeriph": "Mid-Periph",
                        "descemets.periph": "Periph",
                        "descemets.diffuse": "Diffuse",
                        "descemets.quantity": "",
                    };
                }
                return "";
            },
        },
        {
            accessor: "descemets.comments",
        },
    ],
    endothelium: [
        {
            accessor: "endothelium.polymegathism",
            defaultValue: false,
            formatter: (val) => (val ? "Polymegathism noted." : "Cells are uniform in size."),
        },
        {
            accessor: "endothelium.pleomorphism",
            defaultValue: false,
            formatter: (val) => (val ? "Pleomorphism noted." : "Cells are uniform in shape."),
        },
        {
            accessor: "endothelium.stressLines",
            renderer: (data) => {
                const { stressLines } = data?.endothelium ?? {};
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (stressLines && Object.values<any>(stressLines).some((v) => !!v)) {
                    return {
                        "title": "Stress Lines",
                        "endothelium.stressLines.quantity": "",
                        "endothelium.stressLines.severity": "",
                        "endothelium.stressLines.central": "Central",
                        "endothelium.stressLines.midPeriph": "Mid-Periph",
                        "endothelium.stressLines.periph": "Periph",
                        "endothelium.stressLines.diffuse": "Diffuse",
                    };
                }
                return "";
            },
        },
        {
            accessor: "endothelium.comments",
        },
    ],
};
